import React from 'react';
import SimpleReportForm from '../SimpleReportForm';
import GenericSurepassOutputComponent from '../output/GenericSurepassOutputComponent';

const ItrDownloadItrVInputComponent = () => (
    <SimpleReportForm
        banner={{ icon: 'pi-download', title: 'ITR Download ITR-V', subtitle: 'Initiate download of ITR-V (acknowledgement)' }}
        fields={[
            { name: 'client_id', label: 'Client ID', icon: 'pi-key', placeholder: 'itr_xxxxxxxxxxxxx', maxLength: 100, mono: true,
              colClass: 'col-12 md:col-8 lg:col-6' },
        ]}
        endpoint={{
            path: '/surepass/itr/download-itr-v',
            bodyMapper: (v, sid) => ({ client_id: v.client_id.trim(), api_provider_service_id: parseInt(sid, 10) }),
        }}
        consentReportType="itr-download-itr-v"
        submitLabel="Download ITR-V"
        successSummary="ITR-V download initiated"
        errorSummary="ITR-V download failed"
        confirmHeader="Confirm ITR-V download"
        confirmAcceptLabel="Yes, download"
        outputComponent={GenericSurepassOutputComponent}
        outputProps={{ title: 'ITR-V Acknowledgement', icon: 'pi-download' }}
    />
);

export default ItrDownloadItrVInputComponent;
